import { Component, ElementRef, ViewChild, OnInit, Input, EventEmitter, AfterViewInit, ChangeDetectorRef, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { RouterModule, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TabsComponent } from '../tabs/tabs.component';
import { NavLinksService } from '../service/nav-links.service';
import { UserService } from '../service/user.service';
import { SidebarService } from '../service/sidebar.service';
import { MenuService } from '../service/menu.service';
import { Subscription } from 'rxjs';
import { StateService } from '../service/state.service';
import { LoginService } from '../service/login.service';
import { AlertPopupComponent } from '../pages/popups/alert-popup/alert-popup.component';
import { ClientNameService } from '../service/client-name.service';
import { environment } from '../environments/environment';
import { validRouts } from '../../data/ValidRouts';
import { GridTooltipComponent, PAGE_TOOLTIP_TARGET } from '../components/shared/grid-tooltip/grid-tooltip.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterModule, CommonModule, TabsComponent, AlertPopupComponent, GridTooltipComponent],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, AfterViewInit, OnChanges {
  // Page elements that get the black tooltip (app-grid-tooltip around the router outlet):
  // toolbar buttons and every breadcrumb item.
  public readonly pageTooltipTarget = PAGE_TOOLTIP_TARGET;
  // Header controls (profile icon/name, Switch Entity, the profile menu), outside the outlet.
  public readonly headerTooltipTarget = '.navbar-end [title], .navbar-end [data-tip]';
  public navLinks: any[] = [];
  @Input() sidebarToggle?: EventEmitter<void>;
  sidebarToggleSubscription?: Subscription;
  userId: number = 0;
  Role: string = '';
  currentRoute?: string;
  CustomerId: number = 0;
  firstName?: string;
  lastName?: string;
  ClientId?: string;
  clientName?: string;
  SpID!: any;
  sidebarActive = true;
  toggleimg = '../assets/vectors/SidebarToggleoff.svg'
  logoImageUrl = './assets/Images/TeamLeaseRegtech_Logo_new.png';
  logoImageClass = 'nav-open-logo';
  svgIcon = `../assets/vectors/Reports.svg`;
  isFirstLogin = true;
  isEntityFirst = true;
  CustomerName = '';
  isActive: boolean = false;
  subscription!: Subscription;
  alertData = { alertMessage: '', alertVisible: '' }
  sidebarTabMenuToggle = false;
  sidebarTabMenuToggleLicences = false;
  sidebarTabMenuToggleMyDocuments = false;
  entityText: string = '';
  showProfileDropdown: boolean = false;
  sidebarTabMenuToggleELibrary: boolean = false;
  sidebarTabMenuToggleWorkspace = false;
  sidebarTabMenuToggleAuditScreen = false;
  sidebarTabMenuToggleReturnsActivity = false;
  token: any
  selectedMenu: any
  selectedNavLink: any
  toggleProfileDropdown() {
    this.showProfileDropdown = !this.showProfileDropdown;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.profile-container') && !target.closest('.toggle-Profile')) {
      this.showProfileDropdown = false;
    }
  }
  collapseSidebarSublistsOnSidebarToggle() {
    if (this.sidebarActive === true) {
      this.sidebarTabMenuToggleLicences = false;
      this.sidebarTabMenuToggleMyDocuments = false;
      this.sidebarTabMenuToggleAuditScreen = false;
       this.sidebarTabMenuToggleWorkspace = false;
    }else{
      if(this.currentRoute=='/ER1Returns'){
        this.sidebarTabMenuToggleWorkspace = true;
      }else if(this.currentRoute=='/AuditReturnsActivity'||this.currentRoute=='/Audit'){
        this.sidebarTabMenuToggleAuditScreen = true;
      }
    }
  }

  onSidebarTabDownArrayClick(linkID: number) {
    if (!this.userService.getClientId() && (this.Role == 'HMGR' || this.Role == 'HAPPR' || this.Role == 'HRL' || this.Role == 'HRLN' || this.Role == 'HRN')) {
      this.alertData = { alertMessage: 'Select Entity is Required', alertVisible: 'error' }
      return;
    }
    if (linkID === 36) {
      // licences
      this.sidebarTabMenuToggleLicences = !this.sidebarTabMenuToggleLicences
      this.sidebarTabMenuToggleMyDocuments = false;
      this.sidebarTabMenuToggleELibrary = false;
    }

    if (linkID === 8 || linkID === 7) {
      // my documents
      this.sidebarTabMenuToggleMyDocuments = !this.sidebarTabMenuToggleMyDocuments
      this.sidebarTabMenuToggleLicences = false;
      this.sidebarTabMenuToggleELibrary = false;
    }
    if (linkID === 6) {
      this.sidebarTabMenuToggleELibrary = !this.sidebarTabMenuToggleELibrary;
      this.sidebarTabMenuToggleLicences = false;
      this.sidebarTabMenuToggleMyDocuments = false;
    }
    // this.sidebarTabMenuToggle = !this.sidebarTabMenuToggle;
  }

  ELibrarySidebarDummyData: {
    createdDate: string,
    hrefurl: string,
    icon: string,
    id: number,
    imgsrc: string | null,
    level: number,
    menuID: string,
    name: string,
    parentMenuID: string | null,
    status: string,
    updatedDate: string | null
  }[] = [
      {
        createdDate: "2021-12-15T19:28:34.417",
        hrefurl: "/MinimumWagesClientPortal",
        icon: "Minimum_Wages",
        id: 8,
        imgsrc: "../Images/challans.png",
        level: 8,
        menuID: "M38",
        name: "Minimum Wages",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
      },
      {
        createdDate: "2021-12-08T17:18:15.433",
        hrefurl: "/ListOfHolidaysClientPortal",
        icon: "List_of_Holidays",
        id: 7,
        imgsrc: "../Images/List_of_Holidays.png",
        level: 9,
        menuID: "M37",
        name: "List of Holidays",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
         },
      {
        createdDate: "2021-12-08T17:18:15.433",
        hrefurl: "/LabourWelfareFund",
        icon: "Minimum_Wages",
        id: 7,
        imgsrc: "../Images/List_of_Holidays.png",
        level: 9,
        menuID: "M37",
        name: "Labour Welfare Fund",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
      },

    ]

  licencesDummyData: {
    createdDate: string,
    hrefurl: string,
    icon: string,
    id: number,
    imgsrc: string | null,
    level: number,
    menuID: string,
    name: string,
    parentMenuID: string | null,
    status: string,
    updatedDate: string | null
  }[] = [
      {
        createdDate: "2024-12-11T19:16:39.62",
        hrefurl: "/NewRegistrationLicense",
        icon: "Registrations_Icon",
        id: 36,
        imgsrc: null,
        level: 4,
        menuID: "M36",
        name: "Registration",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
      },
      {
        createdDate: "2021-12-23T16:14:00.513",
        hrefurl: "/RegistrationRepository",
        icon: "Registration_Repository",
        id: 12,
        imgsrc: null,
        level: 5,
        menuID: "M12",
        name: "Registration Repository",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
      }
    ]

  myDocumentSidebarDummyData: {
    createdDate: string,
    hrefurl: string,
    icon: string,
    id: number,
    imgsrc: string | null,
    level: number,
    menuID: string,
    name: string,
    parentMenuID: string | null,
    status: string,
    updatedDate: string | null
  }[] = [
      {
        createdDate: "2021-12-15T19:28:34.417",
        hrefurl: "/ClientStatutoryDocument",
        icon: "Stat_Documents_Icon",
        id: 8,
        imgsrc: "../Images/challans.png",
        level: 8,
        menuID: "M08",
        name: "Statutory Documents",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
      },
      {
        createdDate: "2021-12-08T17:18:15.433",
        hrefurl: "/LC_ESIC",
        icon: "Employee_ESIC",
        id: 7,
        imgsrc: "../Images/challans.png",
        level: 9,
        menuID: "M07",
        name: "Employee ESIC",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
      },
      {
        createdDate: "2021-12-08T17:18:15.43",
        hrefurl: "/LC_MIS",
        icon: "MIS_Documents",
        id: 6,
        imgsrc: "../Images/challans.png",
        level: 12,
        menuID: "M06",
        name: "MIS Documents",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
      },
      {
        createdDate: "2022-01-13T19:23:10.977",
        hrefurl: "/CriticalDocuments",
        icon: "Critical_Documents",
        id: 16,
        imgsrc: null,
        level: 15,
        menuID: "M16",
        name: "Critical Documents",
        parentMenuID: null,
        status: "A",
        updatedDate: null,
      },
    ]

  myDocumentSidebarDummyDataSp95 = [
    {
      createdDate: "2021-12-15T19:28:34.417",
      hrefurl: "/ClientStatutoryDocument",
      icon: "Stat_Documents_Icon",
      id: 8,
      imgsrc: "../Images/challans.png",
      level: 8,
      menuID: "M08",
      name: "Statutory Documents",
      parentMenuID: null,
      status: "A",
      updatedDate: null,
    },
  ]

  constructor(
    private navLinksService: NavLinksService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private sidebarService: SidebarService,
    private cdr: ChangeDetectorRef,
    private menuService: MenuService,
    private stateService: StateService,
    private ClientName: ClientNameService,
    private cd: ChangeDetectorRef
  ) { }

  @ViewChild('sidebar', { static: true }) sidebar!: ElementRef;

  ngOnInit(): void {
    // window.addEventListener('popstate', this.onBackClick.bind(this));
    setTimeout(() => {
      if (!sessionStorage.length && !localStorage.length && this.router.url != "/Login") {
        this.logOut();
      }
    }, 5000);
    this.AssignSession();
    this.ClientName.currentClientName$.subscribe(clientName => {
      this.clientName = clientName;
    })

    this.SpID = this.userService.getServiceProviderID();
    if (this.currentRoute == '/CustomerMasters' || this.currentRoute == "/UserMaster"|| this.currentRoute == "/CustomerUserMapping" ||  this.currentRoute == "/ListOfEntities") {
      this.sidebarActive = false;
    }
    this.currentRoute = this.router.url;
    if (this.isFirstLogin) {
      this.toggleSidebar(true);
      this.isFirstLogin = false;
    }

    const allowedRoles = [
      'LSA', 'BT', 'LFT', 'RCP', 'SDEXE', 'CORDN', 'SME', 'HMGR', 'HAPPR',
      'HRL', 'HRLN', 'HRN', 'TLMGT', 'TLACM', 'TLOPH', 'TLCOM', 'TLOPL',
      'TLRM', 'CORDH', 'TLRCH', 'TLAUD'
    ];
    
    if (allowedRoles.includes(this.Role)) {
      this.sidebarActive = true;
      this.AssignSession();
      this.loadSidebarLinks();
      this.toggleSidebar(false);
    }
    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentRoute = this.router.url;
          if (this.currentRoute.split('?')[0] == '/Auth' || this.currentRoute == '/EntityDashboard' || this.currentRoute == "/ClientDashboard") {
            if (this.currentRoute == '/EntityDashboard') {
              this.navLinks = [];
              this.toggleSidebar(true);
              this.CustomerName = '';
              this.ClientId = '';
            }
            else if (this.currentRoute == '/ClientDashboard') {
              this.AssignSession();
              this.loadSidebarLinks();
              this.toggleSidebar(false);
            }
            this.AssignSession();
          }
          else if (this.currentRoute !== '/EntityDashboard' && this.currentRoute !== '/CustomerMasters' && this.currentRoute !== '/UserMaster' && this.currentRoute !== '/CustomerUserMapping' && this.currentRoute !== '/ListOfEntities' && this.Role !== 'SDEXE' && this.Role !== 'RCP' && this.Role !== 'CORDN' &&
            this.Role !== 'SME' && this.currentRoute !== '/EntityMasters' 
            && this.currentRoute !== '/CommercialMappings' && this.currentRoute !== '/EntityAddEdit' && this.currentRoute !== '/CustomerAddEdit'
            && this.currentRoute !== '/EntityBulkUpload' ) {
            this.AssignSession();
            this.loadSidebarLinks();
            this.toggleSidebar(false);
            if (this.userService.getClientId()) {
              this.ClientId = `[${this.userService.getClientId()}]`;
              this.CustomerName = this.userService.getClientName();
            }
          }
          else if (this.Role === 'SDEXE' || this.Role === 'RCP' || this.Role === 'CORDN' || this.Role === 'SME') {
            this.AssignSession();
            this.loadSidebarLinks();
            this.toggleSidebar(false);
            this.CustomerName = '';
            this.ClientId = '';
          }
          else {
            this.navLinks = [];
            this.toggleSidebar(true);
            this.CustomerName = '';
            this.ClientId = '';
          }
          if (this.currentRoute !== '/ListofHolidays' && this.currentRoute != '/ListofHolidaysNotifications') {
            sessionStorage.removeItem('payloadMinimumWages');
          }
          if (this.currentRoute !== '/DocumentGeneration' && this.currentRoute != '/Workspace') {
            sessionStorage.removeItem('month');
            sessionStorage.removeItem('year');
            sessionStorage.removeItem('Input');
            sessionStorage.removeItem('complianceType');
            sessionStorage.removeItem('JsonId');
            sessionStorage.removeItem('formValues');
          }
          this.cdr.detectChanges();
        }
        if (['LSA', 'CORDN', 'BT', 'LFT'].includes(this.Role)) {
          this.ClientId = '';
          this.CustomerName = '';
        }
        this.cdr.detectChanges();
      }

    );
    if (this.isFirstLogin) {
      this.toggleSidebar(true);
      this.isFirstLogin = false;
    }
    this.subscription = this.stateService.isEnabled$.subscribe((value: boolean) => {
      this.isActive = value;
    });
    this.cdr.detectChanges();
    // this.editNoticeService.entity$.subscribe(entity => {
    //   if (entity) {
    //     this.entityText = entity.text;
    //   } else {
    //     this.entityText = '';
    //   }
    // });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const role = this.userService.getRole();
        const SPID = this.userService.getServiceProviderID();
        //const currentRoute = this.router.url.split('/')[1];
        const currentRoute = this.router.url.split('?')[0].split('/')[1];
        if (currentRoute !== 'Login' && currentRoute !== 'ForgetPassword' && currentRoute !== 'SSO' && currentRoute !== 'Auth' && currentRoute !== 'Error') {
          const matchedRoute = validRouts.find(item => item.role === role && item.SPID === SPID && item.tabs.includes(currentRoute));
          if (!matchedRoute) {
            this.error();
          }
        }
      }
    });

  }
  error() {
    this.router.navigate(['/Error', '403']);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.sidebarToggleSubscription = this.sidebarService.sidebarToggle$.subscribe(() => {
        this.toggleSidebar(!this.sidebarActive);
      });
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.SpID = this.userService.getServiceProviderID();
  }

  ngOnDestroy() {
    if (this.sidebarToggleSubscription) {
      this.sidebarToggleSubscription.unsubscribe();
      this.subscription!.unsubscribe();
    }
  }

  setNavName() {
    this.ClientId = `[${this.userService.getClientId()}]`;
    this.CustomerName = this.userService.getClientName();
  }
  gotoEntityDashboard() {
    this.ClientId = '';
    this.CustomerName = '';
    this.router.navigate(['/EntityMasters']);
  }

  // @HostListener('window:beforeunload', ['$event'])
  // onBeforeUnload(event: Event) {
  //    this.logOut();
  // }
  logOut() {
    this.ClientId = '';
    this.CustomerName = '';
    this.navLinksService.LogoutJTIUpdate(this.token).subscribe({
      next: () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/Login';
      },
      error: () => {
        // Optionally handle error 
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/Login';
      }
    });
  }
  checkSidebarByRole() {
    if (this.Role == 'HAPPR') {
      this.myDocumentSidebarDummyData = [
        {
          createdDate: "2021-12-08T17:18:15.433",
          hrefurl: "/LC_ESIC",
          icon: "Employee_ESIC",
          id: 7,
          imgsrc: "../Images/challans.png",
          level: 9,
          menuID: "M07",
          name: "Employee ESIC",
          parentMenuID: null,
          status: "A",
          updatedDate: null,
        },
        {
          createdDate: "2021-12-08T17:18:15.43",
          hrefurl: "/LC_MIS",
          icon: "MIS_Documents",
          id: 6,
          imgsrc: "../Images/challans.png",
          level: 12,
          menuID: "M06",
          name: "MIS Documents",
          parentMenuID: null,
          status: "A",
          updatedDate: null,
        },
        {
          createdDate: "2022-01-13T19:23:10.977",
          hrefurl: "/CriticalDocuments",
          icon: "Critical_Documents",
          id: 16,
          imgsrc: null,
          level: 15,
          menuID: "M16",
          name: "Critical Documents",
          parentMenuID: null,
          status: "A",
          updatedDate: null,
        }]
    } else {
      this.myDocumentSidebarDummyData = [
        {
          createdDate: "2021-12-15T19:28:34.417",
          hrefurl: "/ClientStatutoryDocument",
          icon: "Stat_Documents_Icon",
          id: 8,
          imgsrc: "../Images/challans.png",
          level: 8,
          menuID: "M08",
          name: "Statutory Documents",
          parentMenuID: null,
          status: "A",
          updatedDate: null,
        },
        {
          createdDate: "2021-12-08T17:18:15.433",
          hrefurl: "/LC_ESIC",
          icon: "Employee_ESIC",
          id: 7,
          imgsrc: "../Images/challans.png",
          level: 9,
          menuID: "M07",
          name: "Employee ESIC",
          parentMenuID: null,
          status: "A",
          updatedDate: null,
        },
        {
          createdDate: "2021-12-08T17:18:15.43",
          hrefurl: "/LC_MIS",
          icon: "MIS_Documents",
          id: 6,
          imgsrc: "../Images/challans.png",
          level: 12,
          menuID: "M06",
          name: "MIS Documents",
          parentMenuID: null,
          status: "A",
          updatedDate: null,
        },
        {
          createdDate: "2022-01-13T19:23:10.977",
          hrefurl: "/CriticalDocuments",
          icon: "Critical_Documents",
          id: 16,
          imgsrc: null,
          level: 15,
          menuID: "M16",
          name: "Critical Documents",
          parentMenuID: null,
          status: "A",
          updatedDate: null,
        }]
    }

  }
  loadSidebarLinks() {
    if (this.Role && this.CustomerId && this.SpID) {
      this.navLinksService.getMenuBasedOnRole(this.Role, this.CustomerId, this.SpID, this.userId).subscribe({
        next: (response) => {
          if (response.status === 200) {
            this.setSideBarChild(response.body);
          }
        },
        error: (error) => {
          console.error('Error fetching sidebar data', error);
        }
      });
    } else {
      console.warn("Missing Role, CustomerId or SpID");
    }
  }

  setSideBarChild(nav: any) {
    this.navLinks = nav || [];

    this.checkSidebarByRole(); 
    
    const AuditScreen: any = this.navLinks.find(link => link.id === 41);
    if (AuditScreen) {
      if (!AuditScreen.children) AuditScreen.children = [];

      // Add "Returns Activity" under Audit Screen
      let returnsActivity = AuditScreen.children.find((child: any) => child.id === 1001);
      if (!returnsActivity) {
        returnsActivity = {
          id: 1001,
          name: "Returns Activity",
          icon: "Workspace_Icon",
          hrefurl: "/Audit",
          children: []
        }
        AuditScreen.children.push(returnsActivity);
      }

      // Add "Closure" under Audit Screen
      // let closure = AuditScreen.children.find((child: any) => child.id === 1002);
      // if (!closure) {
      //   closure = {
      //     id: 1002,
      //     name: "Closure",
      //     icon: "Closure_Icon",
      //     hrefurl: "/AuditClosure",
      //     children: []
      //   }
      //   AuditScreen.children.push(closure);
      // }
    }

    //workSpace Changes
    const myWorkspace = this.navLinks.find(link => link.id === 4);
    if (myWorkspace) {
      if (!myWorkspace.children) myWorkspace.children = [];

      let returnsActivity = myWorkspace.children.find((child: any) => child.id === 1001);
      if (!returnsActivity) {
        returnsActivity = {
          id: 1001,
          name: "Returns Activity",
          icon: "Returns_Activity_Icon",
          hrefurl: null,
          children: []
        };
        myWorkspace.children.push(returnsActivity);
      }

      if (!returnsActivity.children) returnsActivity.children = [];

      if (!returnsActivity.children.find((child: any) => child.id === 1002)) {
        returnsActivity.children.push({
          id: 1002,
          name: "ER1 Returns",
          icon: "Workspace_Icon",
          hrefurl: "/ER1Returns"
        });
      }
    }

    this.cd.detectChanges(); // Ensure the view updates
  }

  toggleSidebar(open: boolean) {
    if (this.sidebar.nativeElement) {
      const sidebarElement = this.sidebar.nativeElement as HTMLElement;
      if (open) {
        sidebarElement.classList.add('active');
      } else {
        sidebarElement.classList.remove('active');
      }

      this.sidebarActive = open;

      if (this.sidebarActive) {
        this.toggleimg = '../assets/vectors/SidebarToggleoff.svg'
        this.logoImageUrl = './assets/Images/TeamLease-small.png';
        this.logoImageClass = 'nav-close-logo';
      } else {
        this.toggleimg = '../assets/vectors/SidebarToggle.svg'
        this.logoImageUrl = './assets/Images/TeamLeaseRegtech_Logo_new.png';
        this.logoImageClass = 'nav-open-logo';
      }

      const sidebarBtn = document.querySelector('.sidebarBtn') as HTMLElement;
      if (sidebarBtn) {
        if (this.currentRoute === '/EntityMasters' || this.currentRoute === '/EntityDashboard' || this.currentRoute === '/CustomerMaster' || this.currentRoute === '/UserMaster' || this.currentRoute === '/CustomerUserMapping' || this.currentRoute === '/ListOfEntities') {
          this.ClientId = '';
          this.CustomerName = '';
          if (sidebarElement.classList.contains('active')) {
            sidebarBtn.classList.replace('bx-menu-alt-right', 'bx-menu');
          } else {
            sidebarBtn.classList.replace('bx-menu', 'bx-menu-alt-right');
          }
        } else {
          sidebarBtn.classList.replace('bx-menu', 'bx-menu-alt-right');
        }
      }

      const containerContent = document.querySelector('.container-content') as HTMLElement;
      if (containerContent) {
        if (sidebarElement.classList.contains('active')) {
          containerContent.classList.add('sidebar-active');
        } else {
          containerContent.classList.remove('sidebar-active');
        }
      }
    }
  }

  AssignSession() {
    this.firstName = this.userService.getFirstName();
    this.lastName = this.userService.getLastName();
    this.userId = this.userService.getUserId();
    this.Role = this.userService.getRole();
    this.CustomerId = this.userService.getCustomerId();
    this.ClientId = this.userService.getClientId();
    this.CustomerName = this.userService.getClientName();
    this.SpID = this.userService.getServiceProviderID();
    this.token = this.userService.getAccessToken();
  }

  onSubSidebarLinkClick(linkName: string, navLink: string) {
    if (!this.userService.getClientId() && (this.Role === 'HMGR' || this.Role === 'HAPPR' || this.Role == 'HRL' || this.Role == 'HRLN' || this.Role == 'HRN')) {
      this.alertData = { alertMessage: 'Entity Selection is Required', alertVisible: 'error' };
      return;
    }
    if (linkName === 'Registration Repository') {
      navLink = '/RegistrationRepository';
    }
    else if (linkName === 'MIS Documents') {
      navLink = '/LC_MIS';
    }
    else if (linkName === 'Employee ESIC') {
      navLink = '/LC_ESIC';
    }
    else if (linkName === 'Critical Documents') {
      navLink = '/CriticalDocuments';
    }
    else if (linkName === 'ER1 Returns') {
      navLink = '/ER1Returns';
    }
    this.menuService.setSelectedMenu(linkName);
    this.menuService.selectedMenu$.subscribe(menu => {
      this.selectedMenu = menu;

    });
    if (this.selectedMenu == 'Dashboard') {
      this.selectedMenu = 'My Dashboard'
    }
    if (this.selectedMenu == 'Minimum Wages' || this.selectedMenu == 'List of Holidays') {

      this.selectedNavLink = this.ELibrarySidebarDummyData.find(link => link.name === this.selectedMenu);

    }
    else {
      this.selectedNavLink = this.navLinks.find(link => link.name === this.selectedMenu);
    }
    if (this.Role == 'HMGR' || this.Role == 'HAPPR' || this.Role == 'HMGMT') {
      this.CaptureClientPortalPageWiseDetails()
    }
    sessionStorage.removeItem('currentFolderID')
    sessionStorage.removeItem('breadcrumbs')
    sessionStorage.removeItem('items')
    this.router.navigate([navLink]);
  }

  onSidebarLinkClick(linkName: string, navLink: string) {

    const IsProductMappingApplicable = sessionStorage.getItem('IsProductMappingApplicable')
    if (linkName == 'Home' && IsProductMappingApplicable == '1') {
      //location.replace('https://login.teamleaseregtech.com/ProductMapping/MappingStructure');
      window.location.href = "https://login.teamleaseregtech.com/ProductMapping/MappingStructure";
      return;
    } else if (linkName == 'Home' && (this.Role == 'HMGR' || this.Role == 'HAPPR') && IsProductMappingApplicable == '1') {
      window.location.href = "https://login.teamleaseregtech.com/ProductMapping/MappingStructure";
      return;
    } else if ((this.Role == 'HMGR' || this.Role == 'HAPPR') && linkName == 'Home') {
      this.router.navigate(['/ClientDashboard']);
      return;
    }
    this.sidebarTabMenuToggleLicences = false
    this.sidebarTabMenuToggleMyDocuments = false
    if (!this.userService.getClientId() && (this.Role === 'HMGR' || this.Role === 'HAPPR' || this.Role == 'HRL' || this.Role == 'HRLN' || this.Role == 'HRN')) {
      this.alertData = { alertMessage: 'Entity Selection is Required', alertVisible: 'error' };
      return;
    }
    if (linkName === 'Registration Repository') {
      navLink = '/RegistrationRepository';
    }
    else if (linkName === 'MIS Documents') {
      navLink = '/LC_MIS';
    }
    else if (linkName === 'Employee ESIC') {
      navLink = '/LC_ESIC';
    }
    else if (linkName === 'Critical Documents') {
      navLink = '/CriticalDocuments';
    }
    else if ((this.Role == 'DADMN' || this.Role == 'RVW1') && linkName == 'My Documents') {
      navLink = '/DigitalSignature';
    }


    if (this.selectedMenu == 'Dashboard') {
      this.selectedMenu = 'My Dashboard'
    }
    this.selectedNavLink = this.navLinks.find(link => link.name === this.selectedMenu);
    
    if (this.Role == 'HMGR' || this.Role == 'HAPPR' || this.Role == 'HMGMT') {
      this.CaptureClientPortalPageWiseDetails()
    }
    sessionStorage.removeItem('currentFolderID')
    sessionStorage.removeItem('breadcrumbs')
    if (linkName === 'My WorkSpace') {
      this.sidebarTabMenuToggleWorkspace = !this.sidebarTabMenuToggleWorkspace;
    }
    if (linkName === 'Audit') {
      this.sidebarTabMenuToggleAuditScreen = !this.sidebarTabMenuToggleAuditScreen;
    }
      this.menuService.setSelectedMenu(linkName);
  
      this.menuService.selectedMenu$.subscribe(menu => {
        this.selectedMenu = menu;
  
      });
      if(navLink){
        this.router.navigate([navLink]);
      }
  }

  onSidebarSubLinkClick(linkName: string) {
    if (linkName === 'Existing License') {
      this.router.navigate(['/ExistingRegistrationLicense'])
    } else if (linkName === 'New License Request') {
      this.router.navigate(['/NewRegistrationLicense'])
    } else if (linkName === 'Manage Employee') {
      this.router.navigate(['/ManageEmployee'])
    } else if (linkName === 'Employee CTC') {
      this.router.navigate(['/EmployeeCTCMaster'])
    } else if (linkName === 'Employee Report') {
      this.router.navigate(['/EmployeeMasterReport'])
    }

  }
  changePassword() {
    this.router.navigate(['/ForgetPassword']);
  }
  closeAlert() {
    this.alertData = { alertMessage: '', alertVisible: '' }
  }

  CaptureClientPortalPageWiseDetails() {
    const payload = {
      userID: this.userService.getUserId(),
      clientID: this.userService.getClientId(),
      roleID: this.userService.getRoleId().toString(),
      flag: this.selectedNavLink?.menuID||''
    }

    this.loginService.CaptureClientPortalPageWiseDetails(payload).subscribe({
      next: (response) => {
        if (response.status === 200) {
        } else {
          console.error('Error capturing Client Portal Login Details');
        }
      },
      error: (error) => {
        console.error('Error capturing Client Portal Login Details', error);
      }
    });
  }
  handleWorkspaceClick(event: Event, hrefUrl: string) {
    event.preventDefault();

    this.sidebarTabMenuToggleWorkspace = !this.sidebarTabMenuToggleWorkspace;
    this.router.navigate([hrefUrl]);
  }
}
